import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import './MonitorBlock.css';

/*
All “+” versions do run the Nellcor SpO2. The other versions run the Draeger SpO2. When selecting either Nellcor or Draeger through the dropdown, a different side view will show up.

Masimo is not supported on all the vista models.

Initially we should show the Dräger SpO2 version.
 */

const MonitorBlock = ({ connectionOptions, monitor, getString }) => {

  const history = useHistory();
  const onGoBack = () => {
    history.goBack();
  };

  // find a connection option that works for this monitor
  const foundConnections = connectionOptions
    .filter(option => monitor.connections.includes(option));
  const useConnection = foundConnections.length > 0 ? `-${foundConnections[0]}` : '';
  //console.log('useConnection', useConnection, 'from', monitor.connections, connectionOptions);

  //console.log({monitor, foundConnections, useConnection});

  return (
    <div className="blue-head-block">
      <div
        className="blue-heading"
        onClick={onGoBack}
      >
        <span className="arrow-right" style={{ borderLeftColor: 'white' }} />
        {getString(monitor.id, 'monitor')}
      </div>
      <div className="part-image-block">
        <div className="image-container" style={{ width: '100%', cursor: 'pointer' }} onClick={onGoBack}>
          <img src={`${process.env.PUBLIC_URL}/images/${monitor.id}${useConnection}.jpg`} alt="" className="img-responsive" />
        </div>
      </div>
      <div className="monitor-comments">
        {
          Object.hasOwnProperty.call(monitor, 'comments') && monitor.comments.map(comment => (
            <p key={comment}>{comment}</p>
          ))
        }
      </div>
    </div>
  );
}

MonitorBlock.propTypes = {
  connectionOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  monitor: PropTypes.shape().isRequired,
  getString: PropTypes.func.isRequired
};
export default connect(
  state => ({
    getString: state.strings.getString
  }),
)(MonitorBlock);
